import { render, staticRenderFns } from "./ProductCategoryCreate.vue?vue&type=template&id=3f8413fc&scoped=true"
import script from "./ProductCategoryCreate.vue?vue&type=script&lang=js"
export * from "./ProductCategoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8413fc",
  null
  
)

export default component.exports